import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SinOcRepository } from 'src/app/domain/service/sin-oc/sin-oc-repository';
import {
  CrearTareaRequest,
  CrearTareaResponse,
  GestionLlamadaRequest,
  GestionLlamadaResponse,
  OrdenServicioDetalleHidratada,
  PrepararIngresoCumplimientoRequest
} from 'src/app/domain/model/sin-oc/sin-oc';

/**
 * Adaptador HTTP: HttpSinOcRepository
 *
 * Implementa el puerto SinOcRepository para comunicación HTTP con servicios-ms.
 *
 * Arquitectura Hexagonal:
 * - Este adaptador está en infraestructura
 * - Implementa el puerto SinOcRepository del dominio
 *
 * El backend resuelve el DNI del usuario desde el contexto SSO; ningún endpoint
 * acepta el DNI en headers ni en el body.
 *
 * @author Sura - Migración GWT a Angular
 */
@Injectable({ providedIn: 'root' })
export class HttpSinOcRepository extends SinOcRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/sin-oc`;

  /**
   * {@inheritDoc}
   * POST /api/servicios/sin-oc/tarea
   */
  override async crearTarea(request: CrearTareaRequest): Promise<CrearTareaResponse> {
    return firstValueFrom(
      this.http.post<CrearTareaResponse>(`${this.baseUrl}/tarea`, request)
    );
  }

  /**
   * {@inheritDoc}
   * POST /api/servicios/sin-oc/gestion
   * @legacy CallsManagementHandler → GestionLlamadaFacade.saveOrUpdate()
   */
  override async ingresarGestion(request: GestionLlamadaRequest): Promise<GestionLlamadaResponse> {
    return firstValueFrom(
      this.http.post<GestionLlamadaResponse>(`${this.baseUrl}/gestion`, request)
    );
  }

  /**
   * {@inheritDoc}
   * POST /api/servicios/sin-oc/preparar-ingreso-cumplimiento (HU1132420)
   */
  override async prepararIngresoCumplimiento(
    request: PrepararIngresoCumplimientoRequest
  ): Promise<OrdenServicioDetalleHidratada> {
    return firstValueFrom(
      this.http.post<OrdenServicioDetalleHidratada>(
        `${this.baseUrl}/preparar-ingreso-cumplimiento`,
        request
      )
    );
  }
}
